import Axios from 'axios';

import {
	ALL_APPS_LOADING,
	ALL_APPS_GET,
	ALL_APPS_ERROR
} from './types';

export const get_all_apps = () => dispatch => {
	dispatch({
		type: ALL_APPS_LOADING,
		payload: true
	});
	
	let url = process.env.REACT_APP_SERVER_URL + '/api/apps?skip=0&limit=0';

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: ALL_APPS_GET,
			payload: res.data.apps
		});
		dispatch({
			type: ALL_APPS_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: ALL_APPS_ERROR,
			payload: { type: 'all_apps', msg: err.message }
		});
		dispatch({
			type: ALL_APPS_LOADING,
			payload: false
		});
	})
}
